import withTemasAreaDocente from '../../hoc/Docentes/withTemasAreaDocente';
import ListaTemasArea from "../../view/components/RegistroUsuarios/Clasificacion/VistaClasificacion/ListaTemasArea";

export default withTemasAreaDocente(ListaTemasArea)